export default class Menu {
    constructor() {
        let self = this;
        self.html = document.querySelector('html');
        self.toggleButton = document.querySelector('#menu-toggle');
        self.menuModal = document.querySelector('#menu-mobile');
        this.menuEventListeners();
    }
    menuEventListeners() {
        let self = this;
        this.toggleButton.addEventListener('click', function (e) {
            e.preventDefault();
            self.toggleButton.classList.toggle('active');
            self.menuModal.classList.toggle('mobile-open');
            self.html.classList.toggle('no-scroll');
        });
    }
}
